import { render, staticRenderFns } from "./TabelaResumoImportacoesEntidadesBdgd.vue?vue&type=template&id=3def29f1&"
import script from "./TabelaResumoImportacoesEntidadesBdgd.vue?vue&type=script&lang=js&"
export * from "./TabelaResumoImportacoesEntidadesBdgd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VProgressCircular,VSimpleTable})
